import React from "react";
var __jsx = React.createElement;
import stl from "./page404.module.css";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { CDN_LINK } from "@globalConfig";
var Page404 = function Page404() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/404.svg",
    alt: t("page_found", {
      ns: "web_404"
    })
  }), /*#__PURE__*/React.createElement("h1", null, t("page_found", {
    ns: "web_404"
  })), /*#__PURE__*/React.createElement("p", null, t("browse_cars_go_homepage", {
    ns: "web_404"
  })), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/autos"),
    className: "blueBtn ".concat(stl.btn)
  }, t("browse_cars", {
    ns: "web_404"
  })), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/"),
    className: "whtBtn ".concat(stl.btn)
  }, t("go_homepage", {
    ns: "web_404"
  })));
};
export default Page404;